import { FunctionComponent } from "react";
import { StyledBackButton } from "./back.styles";
import { faChevronLeft } from "components/icon-library";
import { useNavigate } from "react-router";

interface BackButtonProps {
  children: any;
}

const BackButton: FunctionComponent<BackButtonProps> = ({ children }) => {
  const navigate = useNavigate();
  const go = () => {
    navigate(-1);
  };

  return (
    <StyledBackButton preIcon={faChevronLeft} type="tertiary" onClick={go}>
      {children}
    </StyledBackButton>
  );
};

export default BackButton;
